module.exports = __webpack_public_path__ + "img/康复护理.2c1365c6.jpg";